// The coach's brief — headline plus three short lists — rendered the same on
// the ledger digest and on /review.
//
// Shown in full, never folded: the brief exists because the prose before it
// was too long to read, and it is capped server-side at a size that fits.
// YOUR MOVES carries the accent because it is the one section that asks the
// operator to do something.

import type { CoachBrief } from '../lib/types';
import { C, FONT_DISPLAY, FONT_MONO } from '../lib/design';

type Section = {
  key: keyof Omit<CoachBrief, 'headline'>;
  label: string;
  color: string;
};

const SECTIONS: readonly Section[] = [
  { key: 'changed', label: 'WHAT CHANGED', color: C.dim },
  { key: 'watch_for', label: 'WATCH FOR', color: C.warn },
  { key: 'your_moves', label: 'YOUR MOVES', color: C.signal },
];

export function CoachBriefView({ brief }: { brief: CoachBrief }) {
  return (
    <div
      style={{
        border: `1px dashed ${C.line}`,
        padding: '14px 14px 12px',
        display: 'flex',
        flexDirection: 'column',
        gap: 14,
        fontFamily: FONT_MONO,
      }}
    >
      <div
        style={{
          fontFamily: FONT_DISPLAY,
          fontSize: 17,
          lineHeight: 1.35,
          color: C.text,
        }}
      >
        {brief.headline}
      </div>

      {SECTIONS.map(({ key, label, color }) =>
        brief[key].length === 0 ? null : (
          <div key={key}>
            <div
              style={{
                color,
                fontSize: 9,
                letterSpacing: '0.2em',
                fontWeight: 700,
                marginBottom: 6,
              }}
            >
              {label}
            </div>
            <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
              {brief[key].map((line, i) => (
                <li
                  key={i}
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '12px 1fr',
                    fontSize: 12,
                    lineHeight: 1.5,
                    color: C.text,
                    marginTop: i === 0 ? 0 : 5,
                  }}
                >
                  <span style={{ color }}>·</span>
                  <span>{line}</span>
                </li>
              ))}
            </ul>
          </div>
        ),
      )}
    </div>
  );
}
